<template>
    <div class="biggest" ref="content">
        <div style="position: absolute;height: 4vw;display:flex;align-items: center;padding:1vh 0;right: 4.1vw;font-size: 3vw;top: 0.78125vw">
            <div style="font-weight: bold">操作员:{{operatorName?operatorName:'张三'}}</div>
        </div>
        <!--        图片预览功能容器（原图）-->
        <div class="resultImageBox" v-show="resultImageClickEd1" @click="resultImageClickEd1=false">
            <img class="artworkPositon" :src="carousel" alt="">
        </div>
        <!--        识别后的图片的预览功能容器（识别后的图）-->
        <div class="resultImageBox" v-show="resultImageClickEd" @click="resultImageClickEd=false">
            <image-draw-rect5 :style="{transform: 'scale(' + viewScaleValue + ')'}" ref="myImage1" :imageSrc="carousel" :rectObject="rectObject"
            ></image-draw-rect5>
        </div>
        <!--        供用户查看保存下来的图片的容器-->
        <div class="resultImageBox" v-show="checkTakePhoto" @click="checkTakePhoto=false">
            <img class="artworkPositon" :src="showedimageURL" alt="">
        </div>
        <div class="headerAi">
            <img class="headerTextAi" src="../assets/version2.0/aiReport/header.png" alt="" />
        </div>
        <img class="settingHeaderLineAi" src="../assets/version2.0/aiReport/headerLine.png" alt="">
        <!--            标题区域end-->

        <!--            报告内容begin-->
        <div class="reportContent">
            <div class="reportView">
                <!--                    标题区-->
                <div class="reportViewHeader">
                    <img style="width: auto;height: 5.734375vw;position: absolute;left: 50%;transform: translateX(-50%)" src="../assets/version2.0/aiReport/featureHeader.png" alt="">
                    <div class="scoreTitle">AI耳部综合评分</div>
                </div>
                <!--        轮播图区域-->
                <div style="position: relative;display: flex;justify-content: space-around;align-items: center;padding: 2.5vh 0;transform-origin: bottom" :style="{transform:'scale('+bannerScaleValue+')'}">
                    <!-- 得分 -->
                    <div class="scoreAi" style="width: 180px;height: 180px;" :style="{transform:'scale('+processFeatureScaleValue+')'}">
                            <!-- 修改默认的85分 -->
                            <!--                        <process-feature   ture ref="processFeature" class="SYHTwenzi" base-color="" process-color="" offset="" height="170" width="170" :score="allScore">-->
                            <!--                        </process-feature>-->
                            <process-feature ref="processFeature" class="SYHTwenzi processFeature"></process-feature>
                    </div>

                    <!--                    六边形战士-->
                    <div class="hexagon">
                        <div ref="CX" style="top: 9.325vw;left: -0.5vw;white-space: nowrap">出血</div>
                        <div ref="GHB" style="top: 27vw;left: 36.2vw;white-space: nowrap">钙化</div>
                        <div ref="CK" style="top: 27vw;left: -0.5vw;white-space: nowrap">穿孔</div>
                        <div ref="FMW" style="top: 9.325vw;left: 36.2vw;white-space: nowrap">分泌物</div>
                        <div ref="MJ" style="top: 37.5vw;left: 17.5vw;">真菌</div>
                        <div ref="HPS" style="top: -0.2vw;left: 16.7vw;white-space: nowrap">琥珀色</div>
                        <!--                        真正的可视化 其中:score-array="scoreArray"决定分数-->
                        <!--                        <hexagon-feature style="margin-top: 10px" class="SYHTwenzi" :isFeatureHasScore="!isFeatureHasScore" height="170" width="170"-->
                        <!--                                         ref="hexagonFeature"></hexagon-feature>-->
                        <div class="LBXBox" :style="{transform:'scale('+heaxgonStar+')'}">
                            <heaxgon-star ref="hexagonFeature" class="SYHTwenzi"
                                          :score="scoreArray"></heaxgon-star>
                        </div>
                        <img v-show="isFeatureHasScore" class="notFound" src="../assets/version2.0/aiReport/未见异常.png"
                             alt="">
                    </div>
                </div>

                <!--                    鼓膜状态锤突状态区域-->
                <div class="AI-GMCTarea">
                    <div class="AI-GMStatus">
                        <div class="GMpic">
                            <big-choose-small1 ref="bigChooseSmallGMAI"></big-choose-small1>
                        </div>
                        <!--                        <div class="GMStatus-BZQX"></div>-->
                        <div class="CTStatus-noCTMX">
                            <img class="toTop0AndJcc" src="../assets/AIReportPage/GMStatus-title.png">
                            <img class="toBottom0AndJcc" src="../assets/AIReportPage/both-BAQX.png">
                        </div>
                    </div>
                    <div class="AI-CTStatus">
                        <div class="GMpic">
                            <big-choose-small1 ref="bigChooseSmallCTAI"></big-choose-small1>
                        </div>
                        <!--                        <div class="CTStatus-CTMX" v-if="isHaveCT"></div>-->
                        <div class="CTStatus-noCTMX">
                            <img class="toTop0AndJcc" src="../assets/AIReportPage/CTStatus-title.png" alt="">
                            <!--                            标志不清楚-->
                            <img class="toBottom0AndJcc" v-if="!isHaveCT" src="../assets/AIReportPage/CTStatus-BZBQX.png" alt="">
                            <!--                            标志清楚-->
                            <img class="toBottom0AndJcc" v-if="isHaveCT" src="../assets/AIReportPage/both-BAQX.png" alt="">
                        </div>
                    </div>
                </div>

<!--                其中margin-top为统一标准-->
                <div style="position: relative;display: grid;margin-top: 2vh">
                    <div class="featureTextDiv1">
                        <div ref="DN1" style="transform: translateY(-1.953125vw); color: #fff;text-align: center">干净</div>
                        <div ref="PH1" style="transform: translateY(-1.953125vw); color: #fff;">未见异常</div>
                        <!--                            <div style="color: #fff;">偏红</div>-->
                    </div>
                    <div class="featureTextDiv2">
                        <div ref="DN2" style="transform: translateY(-1.953125vw); display: flex;justify-content: center;color: #fff;">少量</div>
                        <div ref="PH2" style="transform: translateY(-1.953125vw); color: #fff;">偏红</div>
                        <!--                            <div style="color: #ff6b6b;">未见异常</div>-->
                    </div>
                    <div class="featureTextDiv3">
                        <div ref="DN3" style="transform: translateY(-1.953125vw); display: flex;justify-content: center;color: #fff;">较多</div>
                        <div ref="PH3" style="transform: translateY(-1.953125vw);   display: flex;justify-content: center;color: #fff;">较红</div>
                        <!--                            <div style="color: #fff;">其他异常</div>-->
                    </div>
                    <div class="reportViewMiddleHeader">
                        <img style="width: auto;height: 5.734375vw;position: absolute;" src="../assets/version2.0/aiReport/featureHeader.png" alt="">
                        <div class="scoreMiddleTitle">AI耳部特征分析</div>
                    </div>
                    <!-- 横着的第一个盒子 -->
                    <div class="featureContainer">
                        <div class="firstRow">
                            <img style="height: 6vw" src="../assets/version2.0/aiReport/ear1.png" alt="">
                            <span>耵聍指数</span>
                        </div>
                        <!-- 特征图片展示区 -->
                        <div class="fuqin"
                             style="background-color: inherit;width: 6.6vh;height: 6.6vh;border-radius: 14%;border-style: solid;border-color: #3f73a7;position: relative;overflow: hidden;">
                            <!-- 真正存放用户刚拍摄的图片 -->
                            <!-- 因为用户查看的是记录 它是不需要了的 -->
                            <!--                            <img v-if="returnData.Score.DNF > 0 ? false : true" style="width: 100%;height: 100%;position: absolute;"-->
                            <!--                                 :src="returnData.img" @click="openImgPre(featureImage)">-->
                            <!-- 下面是用户在温度计超过一半的时候展示的图片 也就是大图取小图 -->
                            <!-- :style="arraySu ? DTYS : ''" -->
                            <div :style="returnData.Score.DNF > 0?DTYS : {}">
                            </div>
                            <!-- 特征正常时展示的背景图片 -->
                            <!--                            因为用户是在查看记录 所以灰色背景直接不要的-->
                            <div v-if="returnData.Score.DNF > 0 ? false : true" class="mask"></div>
                            <!-- 特征正常时展示的打勾图片 -->
                            <!-- <img v-show="isFeatureHasScore" class="correct" src="../assets/version2.0/aiReport/打勾.png"> -->
                            <!-- src="../assets/Success.gif" -->
                            <!-- 每次加载都播放 :src="gifSrc" -->
                            <img v-show="returnData.Score.DNF > 0 ? false : true" style="width: 6.6vh; height: 6.6vh;  position: absolute;"
                                 :src="gifSrc">
                            <div></div>
                        </div>
                        <!-- 右边的类似温度计的展示区 -->
                        <div style="margin-top: 1.44140625vw;width: 60%;position: relative">
                            <img style="width: 101%;margin-bottom: 1.46484375vw" src="../assets/version2.0/aiReport/process1.png"
                                 alt="">
                            <!--                            会动的向上箭头-->
                            <img ref="signal1" class="signal" src="../assets/version2.0/aiReport/signal.png" alt="">
                            <!--                                <div class="featureProcess">-->
                            <!--                                    <div class="progress11" ref="progress1"></div>-->
                            <!--                                </div>-->
                            <!--                                <process-line :score="DN_Flag" ref="processLine"></process-line>-->
                            <img class="featureScale" src="../assets/version2.0/aiReport/刻度.png" alt="">
                        </div>
                    </div>
                    <!-- 横着的第二个盒子 -->
                    <div class="featureContainer">
                        <div class="secondRow">
                            <img style="height: 6vw" src="../assets/version2.0/aiReport/ear2.png" alt="">
                            <span>偏红指数</span>
                        </div>
                        <div class="fuqin"
                             style="background-color: inherit;width: 6.6vh;height: 6.6vh;border-radius: 14%;border-style: solid;border-color: #3f73a7;position: relative;overflow: hidden;">
                            <!-- 因为用户是在看记录 它是不需要了的 -->
                            <!--                            <img v-if="returnData.Score.PHF > 33 ? false : true" style="width: 100%;height: 100%;position: absolute;"-->
                            <!--                                 :src="returnData.result_img" alt="" @click="openImgPre(featureImage)">-->
                            <!-- 下面是用户在温度计超过一半的时候展示的图片 也就是大图取小图 -->
                            <!-- 判断显示与隐藏的方式和上面不大一样 -->
                            <div :style="returnData.Score.PHF > 33 ? DTYSPlus : {}"></div>
                            <div v-if="returnData.Score.PHF > 33 ? false : true" class="mask"></div>
                            <!-- 每次加载都播放 :src="gifSrc" -->
                            <!-- 原判断条件v-show="isFeatureHasScore" -->
                            <img v-if="returnData.Score.PHF > 33 ? false : true" style="width: 6.6vh; height: 6.6vh;  position: absolute;"
                                 :src="gifSrc">
                        </div>
                        <div style="margin-top: 1.44140625vw;width: 60%;position: relative">
                            <img style="width: 101%;margin-bottom: 1.46484375vw" src="../assets/version2.0/aiReport/process2.png"
                                 alt="">
                            <img ref="signal2" class="signal" src="../assets/version2.0/aiReport/signal.png" alt="">
                            <!--                                <div class="featureProcess">-->
                            <!--                                    <div class="progress33" ref="progress2"></div>-->
                            <!--                                </div>-->
                            <!--                                <process-line :score="MJ_Flag"></process-line>-->
                            <img class="featureScale" src="../assets/version2.0/aiReport/刻度.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="reportTextAi">
                <div class="reportTextAiHeader">
                    <span>您的智慧护耳报告</span>
                    <div class="leftEarBoxColod" v-show="ear === 'left'">左耳</div>
                    <div v-show="ear === 'right'">右耳</div>
                </div>
                <!-- 设置分隔 -->
                <div style="border-top: 2px solid white;width: 100%;height: 0;"></div>
                <!-- 正文最外部盒子 -->
                <div class="content">
                    <!--                    操作员-->
                    <!--                    <div style="width: 100%;height:1.5625vw;top: 0;display: flex;justify-content: center;position: absolute">-->
                    <!--                        <div style="font-size: 1.5625vw;width: 12.355848vw;height:3.5149384vh;left: 16.6015625vw; background-color: #fbebd3;border-radius: 1.7574692vh;display: flex;justify-content: center;align-items: center">操作员：{{operatorName?operatorName:'张三'}}</div>-->
                    <!--                    </div>-->
                    <div class="reportTextAiContentFeature">
                            <!-- 特征图标 -->
                            <img style="position: absolute;left: 1vw;top: 1vw;width: 7vw;"
                                 src="../assets/version2.0/aiReport/AI1.png">
                            <div class="reportTextAiContentFeatureTitle"
                                 style="justify-content: space-between;margin-left: 3.90625vw;margin-top: 0.5859375vw;margin-bottom: 0;">
                                <p style="margin-left: 4.29296875vw">特征分析</p>
                                <div style="font-size: 3vw;margin-right: 1.171875vw;margin-top: 0.390625vw">ID:{{ userCode }}</div>

                            </div>
                            <div class="featureContent">
                                <!--                            原图-->
                                <div class="left-hotImage">
                                    <img class="imag-draw1" :src="carousel" alt="" :style="{width:theSameWH+'px',height:theSameWH+'px',borderRadius:0.976562+'vw' }" @click="toShowArtwork">
                                </div>

                                <!--                            识别后的图-->
                                <div class="left-hotImage">
                                    <!-- 结果图 -->
                                    <!--                                <a-image :src="returnData.result_img" alt=""></a-image>-->
                                    <div class="imag-draw2" :style="{ transform: 'scale(' + scaleValue + ')' }">
                                        <image-draw-rect6 ref="draw6" :imageSrc="carousel" :rectObject="rectObject" @click="toDraw"></image-draw-rect6>
                                    </div>
                                </div>
                                <!--                            用户在首页点击拍照保存下来的图片-->
                                <div v-if="isLocalDevice" class="container" style="height: 17.67vh;background-color: #e2e2e2;padding: 9.375px 4.6875px;">
                                    <img v-for="(item,index) in imagesArray" :key="index" class="takePhotoed" :src="item" @click="toCheckTakePhoto(item)" alt="">
                                </div>

                                <!-- 把特征描述遍历出来 -->
                                <div class="right-feature">
                                    <span v-for="( item, index ) in  sortedArray " :key="index" :style="{backgroundColor:item==='鼓膜轮廓清晰'||item==='锤凸明显'?'#31c918':'#ffae00'}" style="color: #ffffff">{{ item }}</span>
                                </div>
                            </div>
                        </div>
                    <div class="reportTextAiContentJudge">
                        <!-- 综合评估标题模块 -->
                        <div class="reportTextAiContentFeatureTitle" style="margin-top: -0.87890625vw;    margin-left: 3.90625vw;">
                            <p style="margin-top: 0.5859375vw;margin-left: 4.29296875vw;">综合评估</p>
                            <img style="position: absolute;left: -3.61328125vw;width: 7vw;"
                                 src="../assets/version2.0/aiReport/AI2.png" alt="">
                        </div>

                        <!-- 综合评估后的建议 -->
                        <div class="textArea">
                            <p style="margin-bottom: 0" v-for="( item, index ) in  returnData.feature_con " :key="index">
                                {{index + 1}}.{{ item }}</p>
                        </div>
                    </div>
                    <!-- 下面的提示文本 -->
                    <div>
                        <span style="display: flex;justify-content: center;font-size: 3vw;">本结果为AI分析得出，不作为临床诊断意见。</span>
                        <span style="display: flex;justify-content: center;font-size: 3vw">如有不适，请到正规医院作进一步检查。</span>
                        <!--                        <div style="width: 46.09375vw;display: flex;justify-content: center">如有不适，请到正规医院作进一步检查。</div>-->
                    </div>

                    <!-- 健康小建议模块 -->
                    <div class="reportTextAiContentSuggest">
                        <!-- 标题 -->
                        <div class="reportTextAiContentFeatureTitle" style="height: 2.63671875vw">
                            <img src="../assets/JKXJYIcon.png" alt="" style="width: 7vw;height: 5vw;position: relative;margin-left: 0.29296875vw">
                            <span style="margin-left: 0.78125vw">健康小建议</span>
                        </div>
                        <!-- 文本 -->

                        <div class="textArea">
                            <p style="margin-bottom:0" v-for="(item, index) in returnData.AI_suggest_con" :key="index">
                                {{ index + 1 }}.{{ item }}</p>
                        </div>
                    </div>
                </div>
            </div>
<!--            <div style="width: 50vw;height: 50vw;background-color: pink;" @click="captureAndSave">点我生成图片试试</div>-->
            <!-- 这个是返回按钮 -->
            <!-- <div class="backDiv">
                <BackButton class="SYHTwenzi" ref="backButton" @click="onclose"></BackButton>
            </div> -->
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import ProcessFeature from "@/components/svg/processFeature.vue";
// import store from "@/store";
// import API_BASE_URL from "../../config";
import heaxgonStar from "@/components/heaxgonStar.vue";
import imageDrawRect5 from "@/components/imageDrawRect5.vue";
import imageDrawRect6 from "@/components/imageDrawRect6.vue";
import BigChooseSmall1 from "@/components/bigChooseSmall1.vue";
import domtoimage from 'dom-to-image';

export default {
    name:"QrPage",
    data() {
        return {
            bigText:'',
            userCode:'',
            message: 'Loading...',
            canshu: '',
            // 是否有锤凸
            isHaveCT:true,
            imgPre:false,
            resultImageClickEd:false,
            resultImageClickEd1:false,
            rectObject: {
                CK: [],
                CT: [],
                CX: [],
                DN: [],
                FMW: [],
                GHB: [],
                GM: [],
                HPS: [],
                MJ: [],
                PH: [],
                SH: [],
            },
            operatorName:'张三',
            url: {
                // //检查摄像头
                // checkCamera: `${API_BASE_URL}/check-camera`,
                // //获取摄像头数据
                // getVideoFeed: `${API_BASE_URL}/get_video_feed`,
                // //AI检测
                // startCheck: `${API_BASE_URL}/start-check`,
                // //截图
                // getPic: `${API_BASE_URL}/gen-pic`,
                // //设置用户信息
                // setUserInfo: `${API_BASE_URL}/set-info`,
                // // 登录
                // login: `${API_BASE_URL}/login`,
                // shutdown: `${API_BASE_URL}/shut-down`,
                // //获取电池信息
                // getBatteryInfo: `${API_BASE_URL}/get-power`,
                //提交识别
                recognize: "https://api.eleflai.com/store-testing-report",
            },
            circleColor: {
                left: "#09fff1",
                right: '#ff748e'
            },
            gifBaseSrc: require('../assets/Success.gif'), // GIF 的基础路径
            cacheBuster: 0, // 用于缓存破坏的计数器
            settingBody: {
                'padding': '0.78125vw 1.171875vw',
                'justify-content': 'center',
            },
            aiReportBody: {
                'padding': '0.78125vw 0',
                'justify-content': 'center',
                overflow: 'hidden'
            },
            arraySU: [],//存储坐标数组的变量
            SFBS: 0,//缩放倍数
            widthScaleFactoDN:0,
            heightScaleFactoDN:0,
            widthScaleFactoPH:0,
            heightScaleFactoPH:0,
            erziW: 0,//子容器宽度
            erziH: 0,//子容器高度
            arraySU1: [],//存储坐标数组的变量
            SFBS1: 0,//缩放倍数
            erziW1: 0,//子容器宽度
            erziH1: 0,//子容器高度
            isTOBreath: false,//控制呼吸灯是否开始
            isDNF: 0,//耵聍分
            isPHF: 0,//偏红分
            checkPassSignal: false,
            wifiSignal: undefined,
            diskUsage: 0,
            ramUsage: 0,
            stopPlayVideo: false,
            UserNameModal: false, //用户名弹框
            open: false,          //诊断报告页面
            openModal: false,     //设置页面
            openPwdModal: false,  //密码弹框
            //显示截图和视频
            photo: false,          //拍照div
            video: false,          //录像div
            camera: false,          //摄像头div
            cameraCheckDisabled: true,  //摄像头检测btn
            cameraTurnOff: false,        //关闭摄像头btn
            loading: false,        //加载动画
            blueBack: true,//蓝色背景
            photoDisabled: true,
            photoSrc: '',          //照片
            videoSrc: '',          //录像
            defaultPassword: "123456",
            password: "123456",       //默认密码
            formState: { password: '' },//获取输入的密码
            changePassword: "",        //要修改的密码
            userName: "",             //输入框获取的用户名
            showUserName: "",         //展示的用户名
            imageSrc: "",
            openAiReportModal: false, //打开AI报告弹窗
            resultImage: "",
            carousel: '',
            //是否已开始检测
            ifStartCheck: false,
            //是否识别成功
            ifRecognize: false,
            hotImage: '',
            //电池容量
            batterySignal: 0,
            //充电中
            batteryCharging: false,
            featurePics: [],
            //左耳和右耳按钮是否被按下
            left: false,
            right: false,
            //摄像头关闭，摄像头开启
            cameraClose: true,
            formData: null,
            scoreArray: '',
            //综合得分
            allScore: 85,
            //特征图
            featureImage: '',
            // AI综合评估
            feature_con: '',
            DN_Flag: 0,
            MJ_Flag: 0,
            //检测后返回的数据
            checkedData: {},
            judgeContent: [],
            DNF: 0,
            PHF: 0,
            // 症状
            flag: [],
            //是否所有特征都为0分
            isFeatureHasScore: true,
            isMask: true,//控制特征框的显示
            DNJKF: 0,
            openUser: false,//控制本抽屉显示与否
            sick_flag: [],
            ear: '',
            returnData: {
                area: {
                    CK: '',
                    CT: '',
                    CX: '',
                    DN: '',
                    GM: '',
                    MJ: '',
                    PH: '',
                    SH: '',
                    FMW: '',
                    GHB: '',
                    HPS: ''
                },
                flag: '',
                Score: {},
                img_name: '',
                result_img: '',
                feature_con: '',
                AI_suggest_con: '',

            },
            isLocalDevice:false,
            imagesArray:[],
            // 中介imagesArray
            intermediaryImagesArray:[],
            showedimageURL:'',
            checkTakePhoto:false,
        };
    },
    components: {
        BigChooseSmall1,
        imageDrawRect6,
        imageDrawRect5,
        heaxgonStar,
        ProcessFeature,
    },
    computed: {
        // index() {
        //     return index
        // },
        // store() {
        //     return store
        // },
        gifSrc() {
            // 通过添加 cacheBuster 作为查询参数来重新加载 GIF
            return `${this.gifBaseSrc}?${this.cacheBuster}`;
        },
        DTYS() {
            return {
                width: (this.arraySU[2] - this.arraySU[0]) + 'px',
                height: (this.arraySU[3] - this.arraySU[1]) + 'px',
                backgroundImage: `url(${this.returnData.img})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: `-${this.arraySU[0]}px -${this.arraySU[1]}px`,
                transform: `scale(${this.widthScaleFactoDN},${this.heightScaleFactoDN})`,
                position: 'absolute', // 添加绝对定位
            }
        },
        DTYSPlus() {
            return {
                width: (this.arraySU1[2] - this.arraySU1[0]) + 'px',
                height: (this.arraySU1[3] - this.arraySU1[1]) + 'px',
                backgroundImage: `url(${this.returnData.img})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: `-${this.arraySU1[0]}px -${this.arraySU1[1]}px`,
                transform: `scale(${this.widthScaleFactoPH},${this.heightScaleFactoPH})`,
                position: 'absolute', // 添加绝对定位
            }
        },
        sortedArray(){
            // 先创建一个新数组，避免直接修改原始数组
            let sorted = [...this.returnData.flag]
            // 定义要优先排序的元素及其顺序
            const priorityItems = ['鼓膜轮廓清晰', '锤凸明显']
            // 遍历优先元素，并将其从原始数组中移除并添加到新数组的开始位置
            for (let i = 0; i < priorityItems.length; i++) {
                const index = sorted.indexOf(priorityItems[i])
                if (index !== -1) {
                    sorted.splice(index, 1)
                    sorted.splice(i, 0, priorityItems[i])
                }
            }
            return sorted
        },
        scaleValue() {
            // 计算屏幕宽度的44%对应的值
            return 0.44 * window.innerWidth / 640
        },
        theSameWH(){
            return 0.44 * window.innerWidth
        },
        adaptationMultiple(){
            return window.innerHeight*0.066+4
        },
        viewScaleValue(){
            return 0.96 * window.innerWidth / 640
        },
        processFeatureScaleValue(){
            return 0.9*window.innerWidth/430
        },
        heaxgonStar(){
            return 1.8*window.innerWidth/430
        },
        bannerScaleValue(){
            return window.innerWidth/430
        }
    },
    mounted() {
        // ID(12138)和路径参数都要分别切割出来
        this.userCode=this.$route.query.id
        console.log("看看路由",this.$route.query)
        const uuid=this.$route.params.uuid
        if (uuid) {
            this.canshu = uuid;
            this.fetchData(uuid);
        } else {
            this.message = 'No data found in query parameters.';
        }
    },
    methods: {
        async fetchData(uuid) {
            try {
                console.log(uuid)
                const res = await axios.get(`https://api.eleflai.com/get-share-phone-report/${uuid}`)
                this.message = res.data || 'No message returned.'
                if(res.data.code===0){
                    if(res.data.data.ear_picker_info){
                        // 将操作员的名字传给detailList组件
                        this.operatorName=res.data.data.ear_picker_info.name
                    }else{
                        this.operatorName='未绑定'
                    }
                    if(res.data.data.returnData.Score.CXF!==0){
                        this.$refs.CX.style.color='red'

                    }else{
                        this.$refs.CX.style.color='#ffffff'
                    }

                    if(res.data.data.returnData.Score.GHBF!==0){

                        this.$refs.GHB.style.color='red'
                    }else{
                        this.$refs.GHB.style.color='#ffffff'
                    }

                    if(res.data.data.returnData.Score.FMWF!==0){

                        this.$refs.FMW.style.color='red'
                    }else{
                        this.$refs.FMW.style.color='#ffffff'
                    }

                    if(res.data.data.returnData.Score.MJF!==0){

                        this.$refs.MJ.style.color='red'
                    }else{
                        this.$refs.MJ.style.color='#ffffff'
                    }

                    if(res.data.data.returnData.Score.HPSF!==0){

                        this.$refs.HPS.style.color='red'
                    }else{
                        this.$refs.HPS.style.color='#ffffff'
                    }

                    if(res.data.data.returnData.Score.CKF!==0){
                        console.log("穿孔分1是",this.CKF)
                        this.$refs.CK.style.color='red'
                    }else{
                        this.$refs.CK.style.color='#ffffff'
                    }
                    let returnData=res.data.data.returnData
                    this.carousel=returnData.img
                    // 现在是前端画框 需要把每个坐标传递给imageDrawRect组件
                    // 每次打开不同用户的报告详情的时候 都应该清空rectObject 因为使用的是push
                    this.rectObject.CK=''
                    this.rectObject.CT=''
                    this.rectObject.CX=''
                    this.rectObject.DN=''
                    this.rectObject.FMW=''
                    this.rectObject.GHB=''
                    this.rectObject.GM=''
                    this.rectObject.HPS=''
                    this.rectObject.MJ=''
                    this.rectObject.PH=''
                    this.rectObject.SH=''
                    // 下面这个判断条件如果成立 说明该特征需要画框
                    if (returnData.area.CK.max_area) {
                        this.rectObject.CK = returnData.area.CK.max_area_rectangle
                        // 不仅仅是把框的坐标传过去 还要把框的颜色传过去
                        this.rectObject.CK.push(returnData.area.CK.color)
                        this.rectObject.CK.push(returnData.area.CK.text)
                    }
                    if (returnData.area.CT.max_area) {
                        this.rectObject.CT = returnData.area.CT.max_area_rectangle
                        // 不仅仅是把框的坐标传过去 还要把框的颜色传过去
                        this.rectObject.CT.push(returnData.area.CT.color)
                        this.rectObject.CT.push(returnData.area.CT.text)
                    }
                    if (returnData.area.CX.max_area) {
                        this.rectObject.CX = returnData.area.CX.max_area_rectangle
                        // 不仅仅是把框的坐标传过去 还要把框的颜色传过去
                        this.rectObject.CX.push(returnData.area.CX.color)
                        this.rectObject.CX.push(returnData.area.CX.text)
                    }
                    if (returnData.area.DN.max_area) {
                        this.rectObject.DN = returnData.area.DN.max_area_rectangle
                        // 不仅仅是把框的坐标传过去 还要把框的颜色传过去
                        this.rectObject.DN.push(returnData.area.DN.color)
                        this.rectObject.DN.push(returnData.area.DN.text)
                    }
                    if (returnData.area.FMW.max_area) {
                        this.rectObject.FMW = returnData.area.FMW.max_area_rectangle
                        // 不仅仅是把框的坐标传过去 还要把框的颜色传过去
                        this.rectObject.FMW.push(returnData.area.FMW.color)
                        this.rectObject.FMW.push(returnData.area.FMW.text)
                    }
                    if (returnData.area.GHB.max_area) {
                        this.rectObject.GHB = returnData.area.GHB.max_area_rectangle
                        // 不仅仅是把框的坐标传过去 还要把框的颜色传过去
                        this.rectObject.GHB.push(returnData.area.GHB.color)
                        this.rectObject.GHB.push(returnData.area.GHB.text)
                    }
                    if (returnData.area.GM.max_area) {
                        this.rectObject.GM = returnData.area.GM.max_area_rectangle
                        // 不仅仅是把框的坐标传过去 还要把框的颜色传过去
                        this.rectObject.GM.push('#89d961')
                        this.rectObject.GM.push(returnData.area.GM.text)
                    }
                    if (returnData.area.HPS.max_area) {
                        this.rectObject.HPS = returnData.area.HPS.max_area_rectangle
                        console.log("@@@@@@@@@@@@@@@@@@@@@@琥珀色里看看琥珀色",this.rectObject.HPS)
                        // 不仅仅是把框的坐标传过去 还要把框的颜色传过去
                        this.rectObject.HPS.push(returnData.area.HPS.color)
                        this.rectObject.HPS.push(returnData.area.HPS.text)
                    }
                    if (returnData.area.MJ.max_area) {
                        this.rectObject.MJ = returnData.area.MJ.max_area_rectangle
                        // 不仅仅是把框的坐标传过去 还要把框的颜色传过去
                        this.rectObject.MJ.push(returnData.area.MJ.color)
                        this.rectObject.MJ.push(returnData.area.MJ.text)
                    }
                    if (returnData.area.PH.max_area) {
                        this.rectObject.PH = returnData.area.PH.max_area_rectangle
                        // 不仅仅是把框的坐标传过去 还要把框的颜色传过去
                        this.rectObject.PH.push(returnData.area.PH.color)
                        this.rectObject.PH.push(returnData.area.PH.text)
                    }
                    if (returnData.area.SH.max_area) {
                        this.rectObject.SH = returnData.area.SH.max_area_rectangle
                        // 不仅仅是把框的坐标传过去 还要把框的颜色传过去
                        this.rectObject.SH.push(returnData.area.SH.color)
                        this.rectObject.SH.push(returnData.area.SH.text)
                    }
                    this.scoreArray=res.data.data.returnData.Score
                    this.$refs.hexagonFeature.forRendering=Math.random()
                    let arr=res.data.data.returnData.Score
                    // 判断那个未见异常的icon是否显示的逻辑
                    let c = 0
                    if (arr['HPSF'] === 0) {
                        c++
                    }
                    if (arr['MJF'] === 0) {
                        c++
                    }
                    if (arr['GHBF'] === 0) {
                        c++
                    }
                    if (arr['FMWF'] === 0) {
                        c++
                    }
                    if (arr['CXF'] === 0) {
                        c++
                    }
                    if (arr['CKF'] === 0) {
                        c++
                    }
                    if (c !== 6){
                        this.isFeatureHasScore = false
                    }else {
                        this.isFeatureHasScore = true
                    }
                    this.DNF=res.data.data.returnData.Score.DNF
                    this.PHF=res.data.data.returnData.Score.PHF
                    this.allScore=res.data.data.returnData.Score.AllJKF;
                    // 更新综合得分
                    this.$refs.processFeature.score = res.data.data.returnData.Score.AllJKF;
                    // 手动触发allScore的变化
                    // 请求成功后把所有数据传给detailList组件，用来展示
                    this.sick_flag = res.data.data.sick_flag;
                    this.returnData = res.data.data.returnData;
                    this.ear = res.data.data.ear;
                    // 坐标也要传
                    // 先是耵聍的坐标
                    this.arraySU=res.data.data.returnData.area.DN.max_area_rectangle
                    // 然后是偏红的坐标
                    this.arraySU1=res.data.data.returnData.area.PH.max_area_rectangle
                    // 前提是最大面积参数不为空
                    if(res.data.data.returnData.area.DN.max_area_rectangle){
                        // 缩放倍数也要传
                        this.SFBS=res.data.data.returnData.area.DN.max_area_rectangle[2]-res.data.data.returnData.area.DN.max_area_rectangle[0]>res.data.data.returnData.area.DN.max_area_rectangle[3]-res.data.data.returnData.area.DN.max_area_rectangle[1]?85 / (res.data.data.returnData.area.DN.max_area_rectangle[2]-res.data.data.returnData.area.DN.max_area_rectangle[0]) : 85 / (res.data.data.returnData.area.DN.max_area_rectangle[3]-res.data.data.returnData.area.DN.max_area_rectangle[1])
                        this.widthScaleFactoDN=this.adaptationMultiple / (res.data.data.returnData.area.DN.max_area_rectangle[2]-res.data.data.returnData.area.DN.max_area_rectangle[0])
                        this.heightScaleFactoDN=this.adaptationMultiple / (res.data.data.returnData.area.DN.max_area_rectangle[3]-res.data.data.returnData.area.DN.max_area_rectangle[1])
                    }
                    if(res.data.data.returnData.area.PH.max_area_rectangle){
                        // 另一个的缩放倍数也别忘了传
                        this.SFBS1=res.data.data.returnData.area.PH.max_area_rectangle[2]-res.data.data.returnData.area.PH.max_area_rectangle[0]>res.data.data.returnData.area.PH.max_area_rectangle[3]-res.data.data.returnData.area.PH.max_area_rectangle[1]?85 / (res.data.data.returnData.area.PH.max_area_rectangle[2]-res.data.data.returnData.area.PH.max_area_rectangle[0]) : 85 / (res.data.data.returnData.area.PH.max_area_rectangle[3]-res.data.data.returnData.area.PH.max_area_rectangle[1])
                        this.widthScaleFactoPH=this.adaptationMultiple / (res.data.data.returnData.area.PH.max_area_rectangle[2]-res.data.data.returnData.area.PH.max_area_rectangle[0])
                        this.heightScaleFactoPH=this.adaptationMultiple / (res.data.data.returnData.area.PH.max_area_rectangle[3]-res.data.data.returnData.area.PH.max_area_rectangle[1])
                    }
                    // 下面这些if语句 决定了 温度计的走动效果和相应文字变红的效果
                    if (this.DNF >= 0 && this.DNF < 33) {
                        this.$refs.DN1.style.color = 'rgb(255, 107, 107)'
                        this.$refs.DN2.style.color = '#ffffff'
                        this.$refs.DN3.style.color = '#ffffff'
                        let x = 0
                        let a = setInterval(() => {
                            x += 1
                            this.$refs.signal1.style.left = x*0.09765625*2 + 'vw'
                            if (x >= (this.DNF * 270 / 100)) {
                                clearInterval(a)
                            }
                        }, 50)
                    }
                    if (this.DNF >= 33 && this.DNF < 66) {
                        this.$refs.DN2.style.color = 'rgb(255, 107, 107)'
                        this.$refs.DN1.style.color = '#ffffff'
                        this.$refs.DN3.style.color = '#ffffff'
                        let x = 0
                        let a = setInterval(() => {
                            x += 1
                            this.$refs.signal1.style.left = x*0.09765625*2 + 'vw'
                            if (x >= (this.DNF * 270 / 100)) {
                                clearInterval(a)
                            }
                        }, 50)
                    }
                    if (this.DNF >= 66 && this.DNF <= 100) {
                        this.$refs.DN3.style.color = 'rgb(255, 107, 107)'
                        this.$refs.DN1.style.color = '#ffffff'
                        this.$refs.DN2.style.color = '#ffffff'
                        let x = 0
                        let a = setInterval(() => {
                            x += 1
                            this.$refs.signal1.style.left = x*0.09765625*2 + 'vw'
                            if (x >= (this.DNF * 270 / 100)) {
                                clearInterval(a)
                            }
                        }, 5)
                    }

                    if (this.PHF >= 0 && this.PHF < 33) {
                        this.$refs.PH1.style.color = 'rgb(255, 107, 107)'
                        this.$refs.PH2.style.color = '#ffffff'
                        this.$refs.PH3.style.color = '#ffffff'
                        let x = 0
                        let a = setInterval(() => {
                            x += 1
                            this.$refs.signal2.style.left = x*0.09765625*2 + 'vw'
                            if (x >= (this.PHF * 270 / 100)) {
                                clearInterval(a)
                            }
                        }, 50)
                    }
                    if (this.PHF >= 33 && this.PHF < 66) {
                        this.$refs.PH2.style.color = 'rgb(255, 107, 107)'
                        this.$refs.PH1.style.color = '#ffffff'
                        this.$refs.PH3.style.color = '#ffffff'
                        let x = 0
                        let a = setInterval(() => {
                            x += 1
                            this.$refs.signal2.style.left = x*0.09765625*2 + 'vw'
                            if (x >= (this.PHF * 270 / 100)) {
                                clearInterval(a)
                            }
                        }, 50)
                    }
                    if (this.PHF >= 66 && this.PHF <= 100) {
                        this.$refs.PH3.style.color = 'rgb(255, 107, 107)'
                        this.$refs.PH1.style.color = '#ffffff'
                        this.$refs.PH2.style.color = '#ffffff'
                        let x = 0
                        let a = setInterval(() => {
                            x += 1
                            this.$refs.signal2.style.left = x*0.09765625*2 + 'vw'
                            if (x >= (this.PHF * 270 / 100)) {
                                clearInterval(a)
                            }
                        }, 50)
                    }

                    // 这个似乎是在重新渲染 加载processFeature组件 综合评分可视化
                    this.$refs.processFeature.load()
                    // 先对图片数组进行清空
                    this.intermediaryImagesArray=''
                    if(res.data.data.images){
                        // 因为返回的图片地址们是一个字符串 所以要进行分割
                        this.intermediaryImagesArray=res.data.data.images.split(',')
                    }else {
                        // 没有拍摄过图片 不展示相应展示框
                        this.isLocalDevice=false
                    }
                    // 把图片数组传过去
                    this.imagesArray=this.intermediaryImagesArray
                    // 因为是手机查看 用户在平板上拍摄的照片肯定是看不到的 所以直接为flase即可
                    // if(res.data.data.serial!==store.state.deviceCode){
                    //     this.isLocalDevice=false
                    // }else {
                    //     if(res.data.data.serial===store.state.deviceCode&&res.data.data.images){
                    //         this.isLocalDevice=true
                    //     }
                    // }
                    if(returnData.area.GM.max_area_rectangle){
                        this.$refs.bigChooseSmallGMAI.featureAreaCoordinates=returnData.area.GM.max_area_rectangle
                        this.$refs.bigChooseSmallGMAI.carousel=returnData.img
                    }
                    if(returnData.area.CT.max_area_rectangle){
                        this.$refs.bigChooseSmallCTAI.featureAreaCoordinates=returnData.area.CT.max_area_rectangle
                        this.$refs.bigChooseSmallCTAI.carousel=returnData.img
                    }
                    // 如果此次记录 锤凸不清楚 那么需要将档案详情页的某个变量设置依霞
                    // 如”标志不清晰“ 此时该展示的
                    if(returnData.area.CT.total_area===0){
                        this.isHaveCT=false
                    }else {
                        this.isHaveCT=true
                    }
                }
                console.log("成功请求到数据了，数据是",this.message)
            } catch (error) {
                this.message = 'Failed to fetch data.';
            }
        },
        toDraw(){
            this.resultImageClickEd=true
            this.$nextTick(()=>{
                // 改变画图组件中的forRendering的值从而触发画图
                // this.$refs.myImage1.forRendering=Math.random()
                this.$refs.myImage1.getRandomColor()
            })
        },
        killColor(){
            this.$refs.DN1.style.color='#fff'
            this.$refs.DN2.style.color='#fff'
            this.$refs.DN3.style.color='#fff'
            this.$refs.PH1.style.color='#fff'
            this.$refs.PH2.style.color='#fff'
            this.$refs.PH3.style.color='#fff'
            this.$refs.hexagonFeature.showCanvas=false
            // 清空锤凸的图片
            // 否则 会出现以下情况：
            // 假设 本次查看的锤凸是完整的 然后我们去查看下一个记录
            // 如果它锤凸不明显 那么它的模块图片是会被填充为我们上一次看到的完整的图片
            this.$refs.bigChooseSmallCTAI.carousel=''
        },
        onclose() {
            // 关闭抽屉 其实就是返回
            this.openUser = false;
            this.open = false
            this.openAiReportModal = false
            this.formState.password = ''
            this.openwifiList = false
            this.$refs.hexagonFeature.scoreArray=''
            // this.$refs.draw6.clearCanvas()
            // this.$refs.draw6.$props.rectObject=''
        },
        openSetting() {
            // this.open = true
            this.$refs.settingPage.open = true
        },
        toShowArtwork(){
            this.resultImageClickEd1=true
        },
        toCheckTakePhoto(item){
            this.showedimageURL=item
            this.checkTakePhoto=true
        },
        captureAndSave() {
            // 使用 dom-to-image 生成页面截图
            domtoimage.toBlob(this.$refs.content)
                .then(blob => {
                    // 创建一个 <a> 元素
                    const link = document.createElement('a');
                    // 将 Blob 转换为图片的 URL
                    link.href = URL.createObjectURL(blob);
                    // 设置下载后的文件名
                    link.download = 'screenshot.png';
                    // 触发点击下载
                    link.click();
                })
                .catch(error => {
                    console.error('生成图片失败', error);
                    alert("哦哦,出错了~")
                })
        }
    }
};
</script>

<style scoped>
@import "../css/AiReport.css";
.biggest{
    position: relative;
    width: 100vw;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0.78125vw 0;
    box-sizing: border-box;
    overflow-x: hidden;
}
.takePhotoed{
    width: 9.375vw;
    height: 9.375vw;
    /*background-color: pink;*/
    border-radius: 0.322265625vw;
    flex: 0 0 auto; /* 阻止盒子缩放 */
    /*每个盒子保持一定间距*/
    margin-left: 5px;
}
.resultImageBox{
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 3000;
    display: flex;
    justify-content: center;
    align-items: center;
    top:0;
}
.artworkPositon{
    /*transform: scale(1);*/
    width: 96vw;
    height: 96vw;
}
.aiReportAction {
    width: 100%;
    display: flex;
    justify-content: center;
}

:root {
    --pressBtn--color: #58d1d9;
    --DN-FLag: 50%;
    --ED-FLag: 33%
}

.SYHTwenzi {
    font-family: 'SYHT', sans-serif;

}
.LBXBox{
    /*position: absolute;*/
    /*!*transform: scale(1.8);*!*/
    /*!*transform: translate(35px,41px);*!*/
    /*!*top:7.8125vw;*!*/
    /*top:17.5vw ;*/
    /*!*left:6.640625vw;*!*/
    /*left: 9.75vw ;*/
    transform-origin: top left;
}

img[src=""] {
    opacity: 0;
}

@keyframes pulse {
    0% {
        transform: scale(1);
        opacity: 1;
    }

    100% {
        transform: scale(0.7);
        opacity: 0;
    }
}

.btnTackPic span {
    margin-bottom: 5em;
}
.fuqin {
    display: grid;
    /* 启用Grid布局 */
    place-items: center;
}
/*.imag-draw1{*/
/*    position: absolute;*/
/*    !*transform: scale(0.61875);*!*/
/*    !*这是在强制宽高为198px，不要做修改，否则将和右边的识别图大小不一致*!*/
/*    min-width: 160px !important;*/
/*    min-height: 160px !important;*/
/*    max-width: 160px !important;*/
/*    max-height: 160px !important;*/
/*    !*top: -4px;*!*/
/*    !*left: 32px;*!*/
/*    !*width: 165px;*!*/
/*    !*height: 165px;*!*/
/*}*/
.imag-draw2{
    position: absolute;
    /*transform: scale({{ scaleValue }});*/
}
.notFound {
    width: auto;
    height: 18vw;
    position: absolute;
    left: 12vw;
    top: 12vw;
}
.button-5 img {
    position: relative;
    right: 2.05078125vw;
    width: 13.671875vw;
    bottom: 0.9765625vw;
}

.reference-img1 img {
    width: 6em;
    height: 6em;
    border-radius: 50%;
    margin: 0 0.1875em;
}

.button-back1 span {
    font-size: 1.625em;
    color: #fff;
    margin: 0 0.55em;
}

.result-img1 img {
    width: 7.375em;
    height: 7.375em;
    border-radius: 50%;
    margin: 0 1em;
}
.headerAi {
    justify-content: center;
    display: flex;
    margin: 1vh 0;
}

.headerTextAi {
    width: auto;
    height: 4vw;
}

.settingHeaderLineAi {
    width: 100%;
    height: auto;
    /*统一标准*/
    margin-bottom: 1vh;
}

.reportContent {
    width: 100%;
    height: 94%;
    /*display: flex;*/
    gap: 1.953125vw;
    padding: 0.48828125vw 1.953125vw;
}

.reportView {
    width: 96%;
    height: 100%;
    background: linear-gradient(110deg, #204b7a 10%, #2a3678);
    border-radius: 2%;
    padding: 2vh 0;
}

.reportViewHeader {
    position: relative;
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 2.44140625vw;
}

.reportViewMiddleHeader {
    width: 100%;
    height: auto;
    justify-content: center;
    align-items: center;
    display: flex;
    position: relative;
    margin: 2.44140625vw 0;
}

.scoreMiddleTitle {
    color: white;
    border-style: hidden;
    position: relative;
    text-align: center;
    /*bottom: 2.1484375vw;*/
    font-size: 3vw;
}

.reportTextAi {
    width: 96%;
    height: 100%;
    background-color: #ecedea;
    border-radius: 2%;
}


.scoreAi {
    position: relative;
    transform-origin:top;
}

.scoreTitle {
    color: white;
    border-style: hidden;
    position: relative;
    text-align: center;
    /*bottom: 2.21484375vw;*/
    font-size: 3vw;
}


.featureContainer {
    display: flex;
    gap: 1.46vw;
    /*margin-left: 2.8vw;*/
    margin-bottom: 1vw;
    justify-content: center;
}

.featureContainer .correct {
    position: absolute;
    width: 4.39453125vw;
    left: 1.7578125vw;
    top: 2.44140625vw;
}

.featureScale {
    width: 54vw;
    height: auto;
}

.featureTextDiv1 {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    position: absolute;
    top: 20vw;
    left: 36vw;
    gap: 12vw;
    font-size: 3vw;
}

.featureTextDiv2 {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    position: absolute;
    top: 20vw;
    left: 57vw;
    gap: 12vw;
    font-size: 3vw;
}

.featureTextDiv3 {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    position: absolute;
    top: 20vw;
    left: 76vw;
    gap: 12vw;
    font-size: 3vw;
}
.reportTextAiHeader {
    display: flex;
    justify-content: center;
    font-weight: 1000;
    font-size: 3.5vw;
    margin-top: 2vh;
    margin-bottom: 2vh;
}


.reportTextAiContentJudge {
    padding: 0.48828125vw 0.48828125vw;
    display: grid;
    gap: 0.48828125vw;
}

.reportTextAiContentSuggest {
    padding: 0.48828125vw 0.48828125vw;
    display: grid;
    /*gap: 5px;*/
}

.reportTextAiContentSuggest {
    padding: 0.48828125vw 0.48828125vw;
    display: grid;
    gap: 0.48828125vw;
}

.identificationChar{
    /*transform: scale(1.725);*/
    /*width: 96vw;*/
    /*height: 96vw;*/
}
.container {
    overflow-x: auto !important; /* 允许水平滚动 */
    overflow-y: hidden;
    white-space: nowrap; /* 保证小盒子水平排列 */
    width: 44.140625vw; /* 大盒子的固定宽度 */
    height: 10.3515625vw; /* 大盒子的固定高度 */
    border: 1px solid #ccc; /* 仅为了视觉效果 */
    display: flex;
    align-items: center;
    border-radius: 0.9765625vw;
}
.container::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 Chrome, Safari 和 Opera */
}
.AI-GMCTarea{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 1vh;
}
.AI-GMStatus{
    width: 43vw;
    height: 8vh;
    background-color: #1a6b94;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 0.4vw;
}
.GMpic{
    position: relative;
    width: 6.6vh;
    height: 6.6vh;
    background-color: rgba(0,0,0,0);
    border:solid rgb(63,115,167);
    border-radius: 14%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}
.AI-CTStatus{
    width: 43vw;
    height: 8vh;
    background-color: #1a6b94;
    border-radius: 8px;
    margin-left: 1.5vw;
    display: flex;
    align-items: center;
    padding: 0.4vw;
}
.CTStatus-noCTMX{
    position: relative;
    width: calc(43vw - 6.6vh);
    height: 6.6vh;
    /*margin-left: 1vw;*/
    /*background-color: pink;*/
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.toTop0AndJcc{
    position: absolute;
    width: 92%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
}
.toBottom0AndJcc{
    position: absolute;
    width: 92%;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}
</style>
